import Konva from 'konva'

function drawRoundedRoute(context, points, radius) {
    if (points.length < 2) return
    context.beginPath()
    context.moveTo(points[0].x, points[0].y)
    for (let index = 1; index < points.length - 1; index++) {
        const previous = points[index - 1]
        const point = points[index]
        const next = points[index + 1]
        const incoming = Math.abs(point.x - previous.x) + Math.abs(point.y - previous.y)
        const outgoing = Math.abs(next.x - point.x) + Math.abs(next.y - point.y)
        const bounded = Math.max(0, Math.min(Math.round(radius), incoming / 2, outgoing / 2))
        if (bounded === 0) context.lineTo(point.x, point.y)
        else context.arcTo(point.x, point.y, next.x, next.y, bounded)
    }
    context.lineTo(points[points.length - 1].x, points[points.length - 1].y)
}

export default class ConnectionRouteShape extends Konva.Shape {
    constructor(config = {}) {
        const routePoints = config.routePoints ?? []
        const cornerRadius = config.cornerRadius ?? 0
        super({
            ...config,
            sceneFunc(context, shape) {
                drawRoundedRoute(context, shape.routePoints, shape.connectionCornerRadius)
                context.fillStrokeShape(shape)
            },
        })
        this.routePoints = routePoints
        this.connectionCornerRadius = cornerRadius
    }

    setRoute(points, cornerRadius = this.connectionCornerRadius) {
        this.routePoints = points ?? []
        this.connectionCornerRadius = Number(cornerRadius) || 0
        this.visible(this.routePoints.length >= 2)
        this.getLayer()?.batchDraw()
    }
}
